export const DESKTOP_RELEASE_URL = "/v1/desktop-releases/latest";

export const DESKTOP_PLATFORMS = ["macos-arm64", "windows-x64"] as const;

export type DesktopPlatform = (typeof DESKTOP_PLATFORMS)[number];

interface NavigatorPlatformSignals {
  platform?: string;
  userAgent?: string;
  maxTouchPoints?: number;
  userAgentData?: { platform?: string };
}

export function detectDesktopPlatform(
  signals: NavigatorPlatformSignals = window.navigator as NavigatorPlatformSignals
): DesktopPlatform | null {
  const fingerprint = [signals.userAgentData?.platform, signals.platform, signals.userAgent]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  if (/windows|win32|win64/u.test(fingerprint)) return "windows-x64";
  if (
    /macos|macintosh|macintel|macppc/u.test(fingerprint) &&
    !/iphone|ipad|ipod/u.test(fingerprint) &&
    (signals.maxTouchPoints ?? 0) < 2
  ) {
    return "macos-arm64";
  }
  return null;
}

export function desktopDownloadUrl(
  platform: DesktopPlatform,
  endpoint = DESKTOP_RELEASE_URL
): string {
  const search = new URLSearchParams({ platform });
  return `${endpoint}?${search.toString()}`;
}

export function desktopPlatformName(platform: DesktopPlatform): string {
  return platform === "windows-x64" ? "Windows" : "macOS";
}
